import type { HostingStatus, Room } from './types';
import type { MessageKey } from './i18n';

export function hostingBlocked(status?: HostingStatus, room?: Room): MessageKey | undefined {
  if (!status) return 'hostingUnavailable';
  if (!room?.enabled) return 'hostingRoomDisabled';
  if (!status.supported) return 'hostingNotConfigured';
  if (status.pending_room_id) return 'hostingBusy';
  if (!status.publisher_available) return 'hostingPublisherUnavailable';
  if (!status.publisher_idle) return 'hostingPublisherActive';
  if (status.participants !== 0) return 'hostingParticipantsConnected';
  return undefined;
}

export function hostingError(code: string): MessageKey {
  const keys: Record<string, MessageKey> = {
    forbidden: 'noAccess', hosting_busy: 'hostingBusy', server_busy: 'hostingBusy',
    hosting_changed: 'hostingChanged', hosting_not_configured: 'hostingNotConfigured',
    hosting_room_disabled: 'hostingRoomDisabled', hosting_publisher_active: 'hostingPublisherActive',
    publisher_unavailable: 'hostingPublisherUnavailable', room_unavailable: 'hostingUnavailable',
    hosting_participants_connected: 'hostingParticipantsConnected',
    hosting_unconfirmed: 'hostingUnconfirmed', hosting_activation_failed: 'hostingFailed',
    hosting_persistence_failed: 'hostingFailed',
  };
  return keys[code] ?? 'hostingFailed';
}
